import script from "./TenantManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantManagement.vue?vue&type=script&setup=true&lang=js"

import "./TenantManagement.vue?vue&type=style&index=0&id=65721ad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65721ad0"]])

export default __exports__